var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"headline d-block"},[_vm._t("title")],2),_c('span',{staticClass:"body-2"},[_vm._t("text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }